// Wallet.js
import React, { useState } from 'react';
import { Dialog, DialogContent, Typography } from '@mui/material';
import TeamSmartWallet from './TeamSmartWallet';

const TeamWallet = ({ onClose }) => {
    const [open, setOpen] = useState(true);
    const [error, setError] = useState('');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    width: '340px',
                    margin: '24px',
                    '& .MuiDialogContent-root': {
                        padding: '24px',
                        '&:first-of-type': {
                            paddingTop: '24px'
                        }
                    }
                }
            }}
        >
            <DialogContent>
                <TeamSmartWallet />
                {error && <Typography color="error" variant="body2">{error}</Typography>}
            </DialogContent>
        </Dialog>
    );
};

export default TeamWallet;